// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.support-container{
    width:100%;
    height: 100%;
    display:flex;
    box-sizing: border-box;
    font-family: "PlusJakartaSans";
    overflow:hidden;
}
.right-container{
    display:flex;
    flex-direction:column;
    width:100%;
    height:100%;
    font-family: "PlusJakartaSans";
}
.support-in-container{
    display: flex;
    flex-direction: column;
    background-color: rgb(248, 248, 255);
    width:100%;
    height:100%;
    padding:1.25rem;
}
.support-in-title-container{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom:1.5rem;
}
.support-in-title-container > span{
    font-size: 1.5rem;
    font-weight: 500;
}
.ticket-button{
    background-color: rgb(64, 64, 242);
    height: 2.5rem;
    border: none;
    border-radius:0.25rem;
    color:white;
    font-family: "PlusJakartaSans";
}
.ticket-button:hover,.ticket-filter-button:hover{
    cursor: pointer;
}
.support-ticket-container{
    display: flex;
    flex-direction: column;
    width:100%;
    height:100%;
    background-color: white;
    border-radius:0.5rem;
    padding:1.5rem;
}
.ticket-title-container{
    width:100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom:2rem;
}
.ticket-title-container > span{
    font-size: 18px;
    font-weight:500;
}
.ticket-filter-button{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding:0.5rem;
    padding-left:1.25rem;
    padding-right:1.25rem;
    font-family: "PlusJakartaSans";
    border:2px solid rgb(64, 64, 242);
    border-radius:0.25rem;
    color: rgb(64, 64, 242);
    background-color: transparent;
    font-size: 16px;
}
.filter{
    height:1rem;
    margin-left:0.25rem;
}
.tickets-container{
    display:grid;
    grid-template-columns: repeat(3,1fr);
    width:100%;
    max-height:77%;
    gap:1.25rem;
    overflow-y:scroll;
}
@media only screen and (max-width: 1240px) and (min-width: 720px) {
    .tickets-container{
        grid-template-columns: repeat(2,1fr);
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/support/support.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,8BAA8B;IAC9B,eAAe;AACnB;AACA;IACI,YAAY;IACZ,qBAAqB;IACrB,UAAU;IACV,WAAW;IACX,8BAA8B;AAClC;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,oCAAoC;IACpC,UAAU;IACV,WAAW;IACX,eAAe;AACnB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,oBAAoB;AACxB;AACA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,kCAAkC;IAClC,cAAc;IACd,YAAY;IACZ,qBAAqB;IACrB,WAAW;IACX,8BAA8B;AAClC;AACA;IACI,eAAe;AACnB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,WAAW;IACX,uBAAuB;IACvB,oBAAoB;IACpB,cAAc;AAClB;AACA;IACI,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,eAAe;AACnB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,cAAc;IACd,oBAAoB;IACpB,qBAAqB;IACrB,8BAA8B;IAC9B,iCAAiC;IACjC,qBAAqB;IACrB,uBAAuB;IACvB,6BAA6B;IAC7B,eAAe;AACnB;AACA;IACI,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,oCAAoC;IACpC,UAAU;IACV,cAAc;IACd,WAAW;IACX,iBAAiB;AACrB;AACA;IACI;QACI,oCAAoC;IACxC;AACJ","sourcesContent":[".support-container{\r\n    width:100%;\r\n    height: 100%;\r\n    display:flex;\r\n    box-sizing: border-box;\r\n    font-family: \"PlusJakartaSans\";\r\n    overflow:hidden;\r\n}\r\n.right-container{\r\n    display:flex;\r\n    flex-direction:column;\r\n    width:100%;\r\n    height:100%;\r\n    font-family: \"PlusJakartaSans\";\r\n}\r\n.support-in-container{\r\n    display: flex;\r\n    flex-direction: column;\r\n    background-color: rgb(248, 248, 255);\r\n    width:100%;\r\n    height:100%;\r\n    padding:1.25rem;\r\n}\r\n.support-in-title-container{\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    margin-bottom:1.5rem;\r\n}\r\n.support-in-title-container > span{\r\n    font-size: 1.5rem;\r\n    font-weight: 500;\r\n}\r\n.ticket-button{\r\n    background-color: rgb(64, 64, 242);\r\n    height: 2.5rem;\r\n    border: none;\r\n    border-radius:0.25rem;\r\n    color:white;\r\n    font-family: \"PlusJakartaSans\";\r\n}\r\n.ticket-button:hover,.ticket-filter-button:hover{\r\n    cursor: pointer;\r\n}\r\n.support-ticket-container{\r\n    display: flex;\r\n    flex-direction: column;\r\n    width:100%;\r\n    height:100%;\r\n    background-color: white;\r\n    border-radius:0.5rem;\r\n    padding:1.5rem;\r\n}\r\n.ticket-title-container{\r\n    width:100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    margin-bottom:2rem;\r\n}\r\n.ticket-title-container > span{\r\n    font-size: 18px;\r\n    font-weight:500;\r\n}\r\n.ticket-filter-button{\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    padding:0.5rem;\r\n    padding-left:1.25rem;\r\n    padding-right:1.25rem;\r\n    font-family: \"PlusJakartaSans\";\r\n    border:2px solid rgb(64, 64, 242);\r\n    border-radius:0.25rem;\r\n    color: rgb(64, 64, 242);\r\n    background-color: transparent;\r\n    font-size: 16px;\r\n}\r\n.filter{\r\n    height:1rem;\r\n    margin-left:0.25rem;\r\n}\r\n.tickets-container{\r\n    display:grid;\r\n    grid-template-columns: repeat(3,1fr);\r\n    width:100%;\r\n    max-height:77%;\r\n    gap:1.25rem;\r\n    overflow-y:scroll;\r\n}\r\n@media only screen and (max-width: 1240px) and (min-width: 720px) {\r\n    .tickets-container{\r\n        grid-template-columns: repeat(2,1fr);\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
